import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from 'lib/ui'
import { useCheckout, useCheckoutContext } from 'lib/modules/checkout'
import { Container } from './styled'

export const PlaceOrder = () => {
  const intl = useIntl()
  const history = useHistory()
  const location = useLocation()
  const isBillingStep = location.pathname.includes('/checkout/billing')
  const { state } = useCheckoutContext()
  const {
    validateCheckout,
    isCheckoutLocked,
    billingAddress,
    shippingAddress,
    shippingMethod,
    isPlacingOrder,
    initPaymentMethod
  } = useCheckout()

  const isSchemaValid = validateCheckout()
  const isProcessing = isCheckoutLocked || isPlacingOrder
  const isCartWorking = isCheckoutLocked ||
    shippingMethod.isFetching ||
    shippingAddress.isFetching ||
    billingAddress.isFetching

  function handlePlaceOrder () {
    if (!isBillingStep) {
      history.push('/checkout/billing')
    }

    if (isSchemaValid) {
      initPaymentMethod()
    }
  }

  return (
    <Container
      isWorking={isCartWorking}
    >
      {isBillingStep && state.isBillingAddressUpdated && (
        <Button
          onClick={handlePlaceOrder}
          isLoading={isProcessing}
          isDisabled={!isSchemaValid}
        >
          {
            intl.formatMessage({
              id: isProcessing ? 'checkout.placeOrder.loading' : 'checkout.placeOrder.action.submit'
            })
          }
        </Button>
      )}
    </Container>
  )
}
